export const TOP_SAFE_AREA_WRAPPER_ID = 'dev-safe-area-wrapper';
export const DEFAULT_TOP_SAFE_AREA_OFFSET_PX = 62;

export const DEV_BACK_BUTTON_ID = 'dev-back-button';
export const DEV_SETTINGS_BUTTON_ID = 'dev-settings-button';
export const DEV_BUTTON_ID = 'dev-button';
